<template>
  <div class="developers-box flex-column">
    <Header1></Header1>
    <el-tabs
      v-model="activeName"
      class="developers-main"
      @tab-click="tabChange"
    >
      <el-tab-pane label="资料管理" name="info">
        <!-- 个人资料管理 -->
        <div class="console-box-content flex-column">
          <div class="console-my-content">
            <el-descriptions
              class="margin-top"
              :title="`我的企业信息`"
              :column="1"
              border
            >
              <template slot="extra">
                <el-button type="primary" @click="openUserDialog"
                  >编辑</el-button
                >
              </template>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  公司名称
                </template>
                {{ userInfo.nickname }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  用户名
                </template>
                {{ userInfo.username }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  手机号
                </template>
                {{ userInfo.phone }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  邮箱
                </template>
                {{ userInfo.mailbox }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  个人信息id
                </template>
                {{ userInfo.id }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  注册日期
                </template>
                {{ userInfo.createDate }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="my-pane" label="应用管理" name="app">
        <div class="pane-app">
          <div class="main-header" style="text-align: end; padding: 10px;">
            <el-button class="add-btn1" type="primary" @click="addApp"
              >创建应用</el-button
            >
          </div>
          <div class="cards">
            <el-card
              class="box-card"
              v-for="(item, index) in cards"
              :key="index"
            >
              <div class="card-item" style="font-size: 18px">
                编号：{{ item.id }}
              </div>
              <div class="card-item">应用名称：{{ item.name }}</div>
              <div class="card-item">
                应用logo：
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.applicationLogo"
                ></el-image>
              </div>
              <div class="card-item">应用说明：{{ item.applicationDesc }}</div>
              <div class="card-item">
                审核状态：{{ item.checkStatus == "0" ? "未审核" : "已审核" }}
              </div>

              <div class="card-item">APPID: {{ item.appId }}</div>
              <div class="card-item">密钥： {{ item.secret || "-" }}</div>
              <div class="card-item">开通日期： {{ item.createdDate }}</div>

              <div class="delete-btn" @click="deleteApp(item)">
                <i class="el-icon-close"></i>
              </div>

              <div
                v-if="item.checkStatus == '0'"
                class="main-header"
                style="text-align: end; padding: 10px;"
              >
                <el-button
                  v-if="item.checkStatus == '0'"
                  class="add-btn1"
                  type="primary"
                  @click="appDetail(item)"
                  >编辑</el-button
                >
              </div>
            </el-card>
          </div>
          <div class="developers-footer flex-row-center">
            <el-pagination
              :page-size="pageSize"
              :current-page="currentPage"
              background
              @current-change="currentChange"
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加或修改个人信息对话框 -->
    <el-dialog
      :title="`编辑企业信息`"
      :visible.sync="infoDialog"
      width="500px"
      append-to-body
    >
      <!-- 企业用户表单 -->
      <el-form
        ref="enterpriseForm"
        :model="enterpriseForm"
        :rules="enterpriseFormRules"
        label-width="100px"
      >
        <el-form-item label="公司名称" prop="nickname">
          <el-input
            v-model="enterpriseForm.nickname"
            placeholder="请输入公司名称"
          />
        </el-form-item>
        <!-- <el-form-item label="用户名" prop="name">
          <el-input
            v-model="enterpriseForm.name"
            placeholder="请输入注册人用户名"
          />
        </el-form-item> -->

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="enterpriseForm.phone" placeholder="请输入手机号" />
        </el-form-item>

        <el-form-item label="邮箱" prop="mailbox">
          <el-input v-model="enterpriseForm.mailbox" placeholder="请输入邮箱" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser">确 定</el-button>
        <el-button @click="infoDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import options from "@/utils/index.js";
import {
  list,
  deleteiptbyid,
  queryaddress,
  editAddr,
  harvestaddress,
  userSave
} from "@/api/console";
import Header1 from "@/components/Header1.vue";
import { enterpriseleveloperlist, deleteAPPbyid } from "@/api/developers";
export default {
  components: {
    Header1
  },
  data() {
    return {
      addrOptions: options,
      addressProps: {
        value: "name",
        label: "name",
        children: "children"
      },
      // 企业用户
      enterpriseForm: {},
      enterpriseFormRules: {
        nickname: [
          { required: true, message: "企业名称不能为空", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      infoDialog: false,
      activeName: "info",
      pageSize: 10,
      total: 10,
      currentPage: 1,
      cards: []
    };
  },
  created() {},
  mounted() {
    this.enterpriseForm = JSON.parse(
      JSON.stringify(this.$store.getters.userInfo)
    );
    this.getList();
  },
  computed: {
    // 登陆用户类型
    userType() {
      return this.$store.getters.userInfo.enterPriseuuid
        ? "enterprise"
        : "user";
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  methods: {
    deleteApp(item) {
      if (item && item.checkStatus == 0) {
        this.$confirm("确认删除此应用?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            deleteAPPbyid(item.id).then(res => {
              setTimeout(() => {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getList();
              }, 1500);
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "success",
          message: "已审核应用不可删除!"
        });
      }
    },
    editUser() {
      this.$refs["enterpriseForm"].validate(valid => {
        if (valid) {
          console.log("---kk --->", this.enterpriseForm);

          // 企业信息保存
          var data = {
            id: this.enterpriseForm.id,

            mailbox: this.enterpriseForm.mailbox,
            nickname: this.enterpriseForm.nickname,
            phone: this.enterpriseForm.phone
          };
          userSave(data).then(res => {
            if (res.code == 200) {
              this.$store.commit("SET_USER_INFO", this.enterpriseForm);
              window.localStorage.setItem(
                "user",
                JSON.stringify(this.enterpriseForm)
              );
              this.infoDialog = false;
              this.$message.success(res.message);
            }
          });
        }
      });
    },
    openUserDialog() {
      this.infoDialog = true;
    },
    tabChange() {},
    currentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    addApp() {
      this.$router.push({
        path: "/appDetail"
      });
    },
    appDetail(item) {
      if (item) {
        window.localStorage.setItem("appDetail", JSON.stringify(item));
      }
      this.$router.push({
        path: "/appDetail"
      });
    },
    getList() {
      let params = {
        entusername: this.$store.getters.userInfo.id,
        size: this.pageSize,
        page: this.currentPage
      };
      enterpriseleveloperlist(params).then(res => {
        if (res.code == 200) {
          this.cards = res.data.records;
          this.total = parseInt(res.data.total);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.developers-box {
  padding: 100px 40px 0;
  width: 100%;
  height: 100%;
  .developers-main {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    .box-card {
      position: relative;
      margin-bottom: 10px;
      .delete-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 20px;
        cursor: pointer;
      }
      .edit-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
        cursor: pointer;
      }
    }
    .card-item {
      margin-bottom: 10px;
      text-align: left;
    }
  }
  .developers-header {
    height: 10%;
    max-height: 60px;
    position: relative;
    padding: 10px 14px;

    .add-btn1 {
      position: absolute;
      right: 0;
      bottom: 5px;
      cursor: pointer;
      padding: 10px 14px;
    }
  }
  .developers-footer {
    height: 10%;
    max-height: 60px;
  }
  .my-pane,
  .pane-app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .pane-app {
    display: flex;
    flex-direction: column;
    .cards {
      overflow-y: scroll;
    }
  }
}
</style>
